import "../../App.css";
import Footer from "../Footer";
import OrderForm from "../OrderForm";
import Reveal from "../Reveal";
import Seo from "../Seo";
// Reuses the bestellen page styling — same layout, request-framed copy.
import "./Bestellen.css";

function Aanvraag() {
    return (
        <>
            <Seo
                title="Aanvraag"
                description="Vraag vrijblijvend een offerte aan voor uw feest of evenement. Wij nemen binnen 24 uur contact met u op."
                path="/aanvraag"
            />
            <section className="bestellen-hero">
                <div className="bestellen-hero-content">
                    <span className="bestellen-eyebrow">AANVRAAG INDIENEN</span>
                    <h1 className="bestellen-title">
                        Vertel ons over uw evenement
                    </h1>
                    <div className="bestellen-rule" aria-hidden="true"></div>
                    <p className="bestellen-subtitle">
                        Vrijblijvend en zonder verplichtingen — wij nemen binnen
                        24 uur contact met u op.
                    </p>
                </div>
            </section>

            <Reveal>
                <OrderForm mode="aanvraag" />
            </Reveal>

            <Footer />
        </>
    );
}

export default Aanvraag;
